export const HttpErrorCodeConst =
{
  invalidCredentialsNeedCaptcha: "invalidCredentialsNeedCaptcha",
  InvalidCredentials: "invalidCredentials"
};
